
<div
  ref="rootEl"
  class="sdv-grid"
  :style="rootStyle"
>
  <template
    v-for="props in internalAreas"
  >
    <slot
      name="area-container"
      v-bind="props"
    >
      <slot
        :name="props.name"
        :area="props.name"
      >
        <div
          :key="props.name"
          v-bind="props.attrs"
        >
          <slot
            :area="props.name"
          />
        </div>
      </slot>
    </slot>
  </template>
</div>
